export default {
      id: "ar-mer-usage",
      viewBox: "0 0 70 60",
      url: "../dist/images/" + "sprite.svg#ar-mer-usage",
      toString: function () {
        return this.url;
      }
    }